import { render, staticRenderFns } from "./SaleCrud.vue?vue&type=template&id=c39d2bee"
import script from "./SaleCrud.vue?vue&type=script&lang=js"
export * from "./SaleCrud.vue?vue&type=script&lang=js"
import style0 from "./SaleCrud.vue?vue&type=style&index=0&id=c39d2bee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports